export const customerIdHeader = 'X-Customer-ID';
export const identityTokenHeader = 'X-Identity-Token';
